import { isEmpty, isNullOrUndefined } from '@app/util/util';
import { HotelFilterTypes, NonRefundableTypes } from '@shared/hotel-itinerary/hotel-filters';
import { CheckboxFilter } from '@shared/filters/entities/fetch-filters.response';
import { staticSelectTranslate } from '@app/helpers/static-translate.helper';
import { HotelFilterVm } from '@shared/magic-filter-bar/entities/filter-types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

const BOARD_KEY = 'HOTEL_FILTER_BAR.TAGS.BOARD';
const BOAR_TRANSLATE = staticSelectTranslate(BOARD_KEY);
const BOARD_FILTER_NAME = BOAR_TRANSLATE !== BOARD_KEY ? BOAR_TRANSLATE : '';

const EXCLUDE_THESE_SELECTED_FILTERS = {
  [HotelFilterTypes.Category]: null,
  [HotelFilterTypes.CheckinTimes]: null,
  [HotelFilterTypes.PromotionalRates]: null,
  [HotelFilterTypes.MemberRatesOnly]: null,
  [HotelFilterTypes.Score]: null,
  [HotelFilterTypes.NonRefundable]: NonRefundableTypes.Refundable,
  [HotelFilterTypes.Boards]: BOARD_FILTER_NAME
};

export const PRIME_KEY = 'PRIME';
export const RAPPICARD_KEY = 'RAPPICARD';

export const HOTEL_FILTER_BAR_TAGS = {
  [HotelFilterTypes.Category]: 'HOTEL_FILTER_BAR.TAGS.CATEGORIES',
  [HotelFilterTypes.CheckinTimes]: 'HOTEL_FILTER_BAR.TAGS.CHECK_IN_TIMES',
  [HotelFilterTypes.Score]: 'HOTEL_FILTER_BAR.TAGS.SCORE',
  [HotelFilterTypes.NonRefundable]: 'HOTEL_FILTER_BAR.TAGS.REFUNDABLE',
  [HotelFilterTypes.Boards]: BOARD_KEY,
  [HotelFilterTypes.PromotionalRates]: 'HOTEL_FILTER_BAR.TAGS.PROMO_RATES',
  [HotelFilterTypes.MemberRatesOnly]: {
    [PRIME_KEY]: 'HOTEL_FILTER_BAR.TAGS.OFFER_PRIME',
    [RAPPICARD_KEY]: 'HOTEL_FILTER_BAR.TAGS.OFFER_RAPPICARD'
  },
  [HotelFilterTypes.Sorters]: 'HOTELS_MODULE.RESULT_HOTELS.SORTER_LABEL'
};

export const HOTEL_FILTER_BAR_TAG_ICONS = {
  [HotelFilterTypes.Category]: Icon.StarOutline,
  [HotelFilterTypes.CheckinTimes]: Icon.Clock,
  [HotelFilterTypes.NonRefundable]: Icon.Monetization,
  [HotelFilterTypes.Boards]: Icon.Restaurant,
  [HotelFilterTypes.PromotionalRates]: Icon.Promotion,
  [HotelFilterTypes.Score]: Icon.HeartOutline,
  [HotelFilterTypes.MemberRatesOnly]: {
    [PRIME_KEY]: Icon.Prime,
    [RAPPICARD_KEY]: Icon.MustacheFlat
  },
};

export function evalHasFilterByExcludeCollection(
  type: string,
  inFilterbar: boolean,
  defaultByInclude: boolean,
  include: boolean | null | undefined,
  criteria: string | null,
): boolean {
  if (!inFilterbar || !(type in EXCLUDE_THESE_SELECTED_FILTERS)) {
    return defaultByInclude ? !!include : !!criteria;
  } else {
    return !!include && !isNullOrUndefined(EXCLUDE_THESE_SELECTED_FILTERS[type]) && !!criteria &&
      EXCLUDE_THESE_SELECTED_FILTERS[type] !== criteria;
  }
}

export function getFiltersByBarWithCriteria(
  filters: HotelFilterVm[], isPrime: boolean, hasRappiCard: boolean
): HotelFilterVm[] {
  return [...filters].filter(filter =>
    filter.type === HotelFilterTypes.Category ||
    filter.type === HotelFilterTypes.PromotionalRates ||
    filter.type === HotelFilterTypes.NonRefundable ||
    filter.type === HotelFilterTypes.CheckinTimes ||
    filter.type === HotelFilterTypes.Score ||
    (
      filter.type === HotelFilterTypes.MemberRatesOnly &&
      (filter.value as CheckboxFilter[]).some(value => value.Count > 0 ) && (isPrime || hasRappiCard)
    ) || (
      filter.type === HotelFilterTypes.Boards && !isEmpty(BOARD_FILTER_NAME) &&
      !isNullOrUndefined((filter.value as CheckboxFilter[]).find(value => value.Text === BOARD_FILTER_NAME))
    )
  ).map(filter => {
    const filterValue = filter.type === HotelFilterTypes.NonRefundable ? NonRefundableTypes.Refundable : BOARD_FILTER_NAME
    if (filter.type === HotelFilterTypes.NonRefundable || filter.type === HotelFilterTypes.Boards) {
      return {
        ...filter,
        value: (filter.value as CheckboxFilter[]).filter(value => value.Text === filterValue),
        order: getFilterBarOrder(filter.type)
      };
    } else {
      return { ...filter, order: getFilterBarOrder(filter.type) };
    }
  });
}

function getFilterBarOrder(type: HotelFilterTypes): number {
  switch (type) {
    case HotelFilterTypes.MemberRatesOnly:
      return 1;
    case HotelFilterTypes.PromotionalRates:
      return 2;
    case HotelFilterTypes.CheckinTimes:
      return 3;
    case HotelFilterTypes.NonRefundable:
      return 4;
    case HotelFilterTypes.Boards:
      return 5;
    default:
      return 6;
  }
}
